import React, { Fragment } from "react";
import { Card, Col } from 'react-bootstrap';
import '../../../../styles/diario.scss'
import moment from 'moment';

const Despesa = (props) => {

    moment.locale('pt');
    moment.updateLocale('pt', {
        months: [
            "Janeiro", "Fevereiro", "Março", "Abril", "Maio", "Junho", "Julho",
            "Agosto", "Setembro", "Outubro", "Novembro", "Dezembro"
        ],
        weekdays: [
            "Domingo", "Segunda", "Terça", "Quarta", "Quinta", "Sexta", "Sábado"
        ]
    });

    return (
        <Fragment>
            <Col>
                <Card className='card-list'>
                    <Card.Body>
                        <Card.Title className="cabeca-card" key={props.key}>Despesa nº {props.despesa._id}</Card.Title>
                        <p>Fonte dos Recursos: {props.despesa.fonte}</p>
                        <p>Credor: {props.despesa.credor}</p>
                        <p>Data: {moment(props.despesa.data).utc(false).format('dddd, DD [de] MMMM [de] YYYY')}</p>
                        <p>Valor: {props.despesa.valor.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL', minimumFractionDigits: 2 })}</p>
                        <p>Objeto: {props.despesa.objeto}</p>
                    </Card.Body>
                </Card>
            </Col>
        </Fragment >)
}

export default Despesa;
